import React from "react";
const StoreContext = React.createContext({
  project: [],
});

export default StoreContext;
